import Vue from 'vue'
import { createApp } from 'vue';
import App from '../components/FavoritProductsFilter.vue';
import 'vs-vue3-select/dist/vs-vue3-select.css';
import '../styles/pagination.css'

createApp(App).mount('#app');